"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CONTENT_TYPE = "application/x-www-form-urlencoded";
var axios_1 = __importDefault(require("axios"));
var IdentityServerConfig = /** @class */ (function () {
    function IdentityServerConfig(BASE_URL, FUNCTIONS_KEY) {
        this.axios = axios_1.default.create({
            baseURL: BASE_URL,
        });
        this.axios.defaults.headers.common["Content-Type"] = CONTENT_TYPE;
        // Interceptors
        this.axios.interceptors.request.use(function (config) {
            return config;
        });
    }
    return IdentityServerConfig;
}());
exports.default = IdentityServerConfig;
